module.exports = __webpack_public_path__ + "static/logo-30ac7f30e4e4de899e01a9c56a5da426.png";